export async function accessAccountResource(payload) {
  const user = window.firebaseAuth?.currentUser;
  if (!user || user.isAnonymous) throw new Error('Verified sign-in required.');
  const token = await user.getIdToken();
  if (window.firebaseAuth.currentUser !== user) throw new Error('Your sign-in has changed.');
  const response = await fetch('https://us-central1-argumentor-ff17a.cloudfunctions.net/accessAccountResource', {
    method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload), cache: 'no-store',
  });
  const result = await response.json();
  if (window.firebaseAuth.currentUser !== user) throw new Error('Your sign-in has changed.');
  if (!response.ok) throw new Error(result.error || 'Account resource access failed.');
  return result.value;
}
export function accountResourceTarget(key) {
  const billingPath = key.match(/^stripe\/users\/([^/]+)$/);
  if (billingPath) return { resource: 'stripe-user', userId: billingPath[1] };
  const match = key.match(/^(mood|agreement-signed|notifications|mentor-settings|siyw-sessions|freemium-usage|vote|stripe-user):([^:]+)$/);
  return match ? { resource: match[1], userId: match[2] } : null;
}
